import script from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"

import "./DocItemMemo.vue?vue&type=style&index=0&id=f757c8a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f757c8a2"]])

export default __exports__